<h3 class="tool-label" title="{{ config.description }}">
  {{ config.label }}
</h3>
<input type="text" placeholder="{{ config.placeholder }}" value="{{ context }}" />
